import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(2, 1.5, 1),
      flex: 1,

      '& > header': {
        marginBottom: theme.spacing(1),

        display: 'flex',
        alignItems: 'flex-end',
        gap: theme.spacing(1),

        '& > h3': {
          fontSize: '1.6rem',
        },
      },
      '& > section': {
        display: 'grid',
        gridTemplate: 'repeat(3, auto) / repeat(2, 1fr)',
        gap: theme.spacing(1),

        '& > span:first-child, & > span:last-child': {
          gridColumn: '1 / 3',
        },

        '& > span': {
          border: '1px solid #F0F0F0',
          borderRadius: 5,
          padding: theme.spacing(0.4, 2),

          display: 'flex',
          gap: 3,

          '& p': {
            fontSize: '1.2rem',
          },

          '& > p:first-child': {
            fontWeight: 600,
          },

          '&:last-child div': {
            flex: 1,

            display: 'flex',
            justifyContent: 'end',
            gap: '2.4rem',

            '& p': {
              fontWeight: 600,
            },
          },
        },
      },
    },
    summaryTable: {
      width: '100%',
      borderSpacing: '0 0.4rem',
      textAlign: 'center',

      '& > thead, & > tbody': {
        flex: 1,

        '& th, & td': {
          fontWeight: 400,
          padding: '0.8rem 0.2rem',
          verticalAlign: 'text-top',

          '&:nth-child(1)': {
            paddingLeft: '0.6rem',
            paddingTop: '1.4rem',

            width: '3rem',
            fontSize: '2rem',
            lineHeight: 0,
          },

          '&:nth-child(2)': {
            textAlign: 'left',

            '&::first-letter': {
              textTransform: 'uppercase',
            },
          },

          '&:nth-child(3)': {
            minWidth: '5rem',
          },

          '&:nth-child(4)': {
            paddingRight: '0.4rem',
          },
        },

        '& td': {
          verticalAlign: 'top',
          fontSize: '1.2rem',
          fontFamily: theme.typography.body1.fontFamily,
          '& > ul': {
            margin: 0,
            padding: 0,
            fontWeight: 600,
            listStyle: 'none',

            '& > li > span': {
              marginRight: 8,
              fontSize: '1.6rem',
              lineHeight: 0,
            },
          },
        },

        '& th': {
          backgroundColor: theme.palette.background.default,
          fontSize: '1.2rem',
          fontFamily: theme.typography.body1.fontFamily,

          '&:first-child': {
            paddingTop: '0.4rem',

            borderTopLeftRadius: 5,
            borderBottomLeftRadius: 5,
          },

          '&:last-child': {
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
          },

          '&:nth-child(2)': {
            fontWeight: 600,
          },
        },
      },
    },
    classifications: {
      '& > tr': {
        '& > th': {
          backgroundColor: 'transparent',
        },
      },
    },
  }),
)
